/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import axios from 'axios';
import * as Icon from 'react-feather';
import YouTube from 'react-youtube';
import Vimeo from '@u-wave/react-vimeo';
import QuerySearch from 'stringquery';

import Config from '../../Config';

import Icon44 from '../../assets/images/icon44.png';

import Icon10 from '../../assets/images/icon10.png';
import Icon41 from '../../assets/images/icon41.png';
import Icon42 from '../../assets/images/icon42.png';
import Img4 from '../../assets/images/event_fixed_banner.jpg';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: '100%',
    maxWidth: '1024px',
  },
};

const streamOpts = {
  autoplay: true,
  hidectrlvar: true,
  showenjlogo: false,
};

let player = null;

Modal.setAppElement('#root');

class VideoPlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        const _this = this;
        const timerFunc = () => {
          const stream = _this.props.videoUrl;
          const streamType = _this.props.videoType;

          console.log(stream);
          console.log(streamType);

          if (streamType === 'http') {
            console.log('Make new player');

            const video = document.createElement('video');

            video.src = stream;

            video.controls = true;
            video.muted = false;
            video.autoplay = true;
            video.height = 450; // in px
            video.width = 800; // in px

            const box = document.getElementById('streamPlayerContainerView');
            box.appendChild(video);

            // player = window.enj_add_player(
            //   'streamPlayerContainerView',
            //   null,
            //   stream.startsWith('https') || stream.startsWith('rtmps'),
            //   stream,
            //   null, // Img4,
            //   streamOpts,
            //   null,
            //   null,
            //   null,
            //   false,
            //   _this.handlerMsgFromPlayer,
            // );
            console.log(player);
          }
        };
        setTimeout(timerFunc, 100);
      }
    }
  }

  handlerMsgFromPlayer = (playerState, msg, data) => {
    console.log(msg);
  };

  renderPlayer = () => {
    const stream = this.props.videoUrl;
    const streamType = this.props.videoType;

    if (streamType === 'http') {
      return null;
    }
    if (streamType === 'youtube') {
      player = null;
      // YouTube Options
      const youTubeOpts = {
        playerVars: {
          autoplay: 1,
        },
      };
      let code = stream;
      if (stream.indexOf('https://youtu.be/') > -1) {
        code = stream.replace('https://youtu.be/', '');
        code = code.replace('/', '');
      } else if (stream.indexOf('http') > -1) {
        const link = stream.substring(stream.indexOf('?'));
        const query = QuerySearch(link);
        console.log(query);
        code = query.v;
      }

      return (
        // eslint-disable-next-line no-underscore-dangle
        <YouTube videoId={code} opts={youTubeOpts} onReady={this._onReady} />
      );
    }
    if (streamType === 'vimeo') {
      return <Vimeo video={stream} autoplay />;
    }
    return null;
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
        style={modalStyles}
        contentLabel="Select Team"
        shouldCloseOnOverlayClick={false}
      >
        <div
          className="kcontent modal"
          style={{ width: 'auto', paddingBottom: 0 }}
        >
          <div className="close-btn">
            <Icon.X onClick={this.props.onRequestClose} />
          </div>

          {this.props.isOpen ? (
            <div className="streamContainer" id="streamPlayerContainerView">
              {this.renderPlayer()}
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    authStatus: state.auth.login.login,
    profile: state.auth.login.values,
    user: state.auth.login,
  };
};

export default connect(mapStateToProps, {})(VideoPlay);
